<mat-form-field style="margin-top: 15px; width: 100%">
  <mat-label>MFA Code:</mat-label>
  <input matInput type="text" [placeholder]="placeholder"  [formControl]="formControl">
  <mat-error style="font-size: 12px">No spaces and length of 6</mat-error>
</mat-form-field>

